import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { LuxIcon, Color } from '@lux/wardrobe-lib'
import { ResourcesService } from '@/app/services/ResourcesService'
import { ResourceProps, ResourceType, TreeFolderProps } from '@/app/models/new-resource'
import DialogSelectRecursiveFolder from '../../UI/Dialogs/DialogSelectRecursiveFolder/DialogSelectRecursiveFolder'
import './ReferenceFolder.scss'

const ReferenceFolder = (props: {
    loading: boolean
    loadingFolders: boolean
    folders: ResourceProps[]
    resourceType: ResourceType
    referenceFolderId: string
    referenceFolderObject: ResourceProps
    setFullLoading: (fullLoading: boolean) => void
    loadMoreFolders: (treeFolder: TreeFolderProps) => void
    setReferenceFolderId: (referenceFolderId: string) => void
    setReferenceFolderObject: (referenceFolderObject: ResourceProps) => void
    setFoldersDetails: (details: any) => void,
    onChangeFolder: (folder: any) => void
}) => {
    const {
        loading,
        folders,
        loadingFolders,
        resourceType,
        referenceFolderId,
        referenceFolderObject,
        setFullLoading,
        loadMoreFolders,
        setReferenceFolderId,
        setReferenceFolderObject,
        setFoldersDetails,
        onChangeFolder = () => { }
    } = props

    const intl = useIntl()

    const componentClass = 'smart-modals-new-resource-reference-folder'

    const [openDialogSelectFolder, setOpenDialogSelectFolder] = useState<boolean>(false)

    const dialogTitle = intl.formatMessage({
        id: 'modals.new_resource.dialog.title.select_folder',
        defaultMessage: 'Select Folder',
    })

    const dialogDescription = intl.formatMessage({
        id: 'modals.new_resource.dialog.description.select_folder',
        defaultMessage: 'Select the reference folder.',
    })

    useEffect(() => {
        folders.map((folder) => {
            if (folder._id === referenceFolderObject._id) {
                setReferenceFolderObject({ ...referenceFolderObject, title: folder.title })
            }
        })
    }, [folders])

    const onSaveDialogSelectFolder = () => {
        if (referenceFolderId) {
            setFullLoading(true)
            ResourcesService.GetFolder({ folderId: referenceFolderId })
                .then((res: any) => {
                    if (res && res.data) {
                        const folderDetails = res.data
                        setFoldersDetails(folderDetails)
                        setReferenceFolderObject({
                            _id: folderDetails?._id,
                            title: folderDetails.title,
                            folderType: folderDetails?.folderType,
                            storeList: folderDetails?.storeList,
                            visibility: folderDetails.visibility,
                            countryList: folderDetails.countryList,
                            bannerList: folderDetails.bannerList,
                            regionList: folderDetails.regionList
                        });
                        onChangeFolder(folderDetails)
                    }
                })
                .finally(() => setFullLoading(false))
            //     ResourcesService.GetResources({ folderId: referenceFolderId })
            //         .then((res: any) => {
            //             if (res && res.data && res.data.data && res.data.data?.length === 1) {
            //                 setReferenceFolderObject(res.data.data[0])
            //                 setFullLoading(false)
            //             }
            //         })
            //         .catch((error: Error) => {
            //             setFullLoading(false)
            //         })
            // } else {
            //     setReferenceFolderId("")
        }
        setOpenDialogSelectFolder(false)
    }

    const onHideDialogSelectFolder = () => {
        setReferenceFolderId('')
        setOpenDialogSelectFolder(false)
    }

    return (
        <>
            {loadingFolders ? (
                <div className="smart-modals--loading">
                    <LuxIcon icon="loading" color={Color.WHITE} />
                </div>
            ) : (
                <></>
            )}
            <div className={componentClass}>
                <div className={`${componentClass}__select`}>
                    <div className={`${componentClass}__select__icon`}>
                        <LuxIcon icon="folder-plus" />
                    </div>
                    <div
                        className={`${componentClass}__select__label${
                            referenceFolderObject?._id ? ' isSelected' : ''
                        }`}>
                        {referenceFolderObject?.title || dialogDescription}
                    </div>
                    <div
                        className={`${componentClass}__select__input`}
                        onClick={() => setOpenDialogSelectFolder(true)}>
                        {intl.formatMessage({
                            id: 'modals.new_resource.input.change',
                            defaultMessage: 'Change',
                        })}
                    </div>
                </div>
            </div>
            <DialogSelectRecursiveFolder
                folders={folders}
                loading={loading}
                title={dialogTitle}
                description={dialogDescription}
                visible={openDialogSelectFolder}
                selectedFolderId={referenceFolderId}
                selectedFolderObject={referenceFolderObject}
                onSave={onSaveDialogSelectFolder}
                onHide={onHideDialogSelectFolder}
                loadMoreFolders={loadMoreFolders}
                setSelectedFolderId={setReferenceFolderId}
                setSelectedFolderObject={setReferenceFolderObject}
            />
        </>
    )
}

export default ReferenceFolder
